export const birthdays = {
  title: "Birthdays at Gándara",
  subtitle: "Celebrate your child's birthday in our natural space with unique and fun activities",
  courseYear: "2025-2026 School Year",
  
  gallery: {
    title: "Birthday moments at Gándara",
    caption: "A special space to celebrate surrounded by nature",
    images: [
      {
        src: "/lovable-uploads/patio-recetas-flores.jpg",
        alt: "Children enjoying Gándara's natural spaces"
      },
      {
        src: "/lovable-uploads/corro-plaza-piedra.png",
        alt: "Outdoor birthday activities"
      },
      {
        src: "/lovable-uploads/patio-rampa-pales.png",
        alt: "Celebration-ready spaces"
      }
    ]
  },
  
  generalInfo: {
    title: "General Information",
    availabilityLabel: "Availability",
    availability: "Friday afternoons, Saturdays and Sundays",
    durationLabel: "Duration",
    duration: "3-4 hours",
    description: "We offer a unique space to celebrate children's birthdays in a natural and respectful environment. Our celebrations are designed for children to enjoy a memorable experience surrounded by nature, with educational and playful activities that encourage creativity and free play."
  },
  
  plans: {
    title: "Available Plans",
    priceNote: "up to 15 children",
    aTuAire: {
      name: "Your Own Way",
      description: "Private space for your celebration",
      features: [
        "Use of our facilities",
        "Access to natural areas",
        "No educational accompaniment"
      ],
      priceSmall: "€120",
      priceLarge: "€180"
    },
    acompanada: {
      name: "Accompanied",
      description: "With professional entertainer",
      features: [
        "Everything included in 'Your Own Way'",
        "Educational entertainer",
        "1 guided workshop of your choice"
      ],
      priceSmall: "€250",
      priceLarge: "€400"
    },
    experienciaCompleta: {
      name: "Complete Experience",
      description: "The most special celebration",
      badge: "Recommended",
      features: [
        "Everything included in 'Accompanied'",
        "2 guided workshops of your choice",
        "Themed decoration",
        "Prepared snack area"
      ],
      priceSmall: "€400",
      priceLarge: "€500"
    }
  },
  
  pricingTable: {
    title: "Pricing Table",
    headers: {
      plan: "Plan",
      small: "Up to 15 children",
      large: "16-30 children"
    }
  },
  
  workshops: {
    title: "Available Workshops",
    items: [
      "Play corners",
      "Art workshop",
      "Face painting",
      "Giant bubbles",
      "Creative cooking",
      "Sensory play",
      "Bracelet making",
      "DIY (Do It Yourself)"
    ]
  },
  
  extras: {
    title: "Available Extras",
    items: [
      { name: "Mini-Disco", price: "€50" },
      { name: "Adult snacks", price: "€6/person" },
      { name: "Additional cleaning", price: "€30" },
      { name: "Birthday cake", price: "€40" },
      { name: "Additional workshop", price: "€50" }
    ]
  },
  
  booking: {
    title: "Booking Process",
    deposit: "Deposit",
    depositDescription: "A €50 deposit is required, which will be deducted from the final celebration price.",
    cancellation: "Cancellation Policy",
    cancellationDescription: "Cancellations must be made at least 1 week in advance for full deposit refund."
  },
  
  form: {
    title: "Reservation Request",
    contactSection: "Contact Information",
    birthdaySection: "Birthday Details",
    preferencesSection: "Preferences",
    extrasSection: "Extras (Optional)",
    
    fields: {
      parentName: "Parent's name",
      email: "Email",
      phone: "Phone",
      childName: "Child's name",
      childAge: "Child's age",
      numberOfChildren: "Number of guest children",
      preferredDate: "Preferred date",
      alternativeDate: "Alternative date (optional)",
      selectedPlan: "Selected plan",
      preferredWorkshops: "Preferred workshops (maximum 2)",
      adultSnacksCount: "Number of adults",
      comments: "Additional comments",
      acceptTerms: "I accept the terms and conditions"
    },
    
    placeholders: {
      parentName: "Mary Smith",
      email: "mary@example.com",
      phone: "+34 600 123 456",
      childName: "Birthday child's name",
      comments: "Preferences, special needs... If any child has allergies, just tell us which ones and how many children, without names."
    },
    
    submit: "Send reservation request",
    submitting: "Submitting...",
    success: "Request submitted successfully! We will contact you soon.",
    error: "Error submitting request. Please try again."
  },
  
  contact: {
    title: "Have questions?",
    description: "Contact us for more information about availability, prices, and customization options.",
    emailButton: "Contact by email"
  }
};
